
<dx-select-box #dx [itemTemplate]="itemTemplate()? 'itemTemplate' : 'item'" [dataSource]="computedDataSource()" [valueExpr]="valueExpr()"
    [displayExpr]="displayExpr()" [grouped]="grouped()" [groupTemplate]="groupTemplate() ? 'groupTemplate' : 'group'" [value]="value()"
    (onValueChanged)="onValueChanged($event)" (onBlur)="onTouched()" [isValid]="isValid" searchMode="contains" [searchExpr]="computedSearchExpr()"
    [searchTimeout]="200" [minSearchLength]="0" [searchEnabled]="true" [showDataBeforeSearch]="false" placeholder="None" [disabled]="disabled()" [readOnly]="readonly()" [inputAttr]="inputAttr()">
    <div *dxTemplate="let data of 'itemTemplate'">
        <ng-template [ngTemplateOutlet]="itemTemplate()" [ngTemplateOutletContext]="{ $implicit: data }"></ng-template>
    </div>
    <div *dxTemplate="let data of 'groupTemplate'">
        <ng-template [ngTemplateOutlet]="groupTemplate()" [ngTemplateOutletContext]="{ $implicit: data }"></ng-template>
    </div>
</dx-select-box>